"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  COPY_LINK_KEY: true,
  SHOW_ALL_VENDORS_KEY: true,
  VENDOR_DATA_ATTRIBUTE: true
};
exports.VENDOR_DATA_ATTRIBUTE = exports.SHOW_ALL_VENDORS_KEY = exports.COPY_LINK_KEY = void 0;
var _constantsGenerated = require("./constants-generated");
Object.keys(_constantsGenerated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constantsGenerated[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constantsGenerated[key];
    }
  });
});
const COPY_LINK_KEY = exports.COPY_LINK_KEY = 'link';
const SHOW_ALL_VENDORS_KEY = exports.SHOW_ALL_VENDORS_KEY = `${_constantsGenerated.APP_NAME} show all vendors`;
const VENDOR_DATA_ATTRIBUTE = exports.VENDOR_DATA_ATTRIBUTE = 'data-vendor';